<template>
  <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-primary"
      class="btn-icon rounded-circle"
      v-b-tooltip.hover.v-primary.top="$t('message.viewRRHistory')"
      @click="$emit('clicked')"
  >
    <feather-icon icon="ClockIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'RecordButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
}
</script>

<style scoped>

</style>
